/**
 * 학생 화면 하단에 붙는 공통 푸터. 회사 정보(사업자등록번호·주소 등)와
 * 문의하기·이용약관·개인정보처리방침으로 가는 링크를 담는다.
 *
 * "이용약관" 클릭 시에는 페이지 이동 없이 이 컴포넌트가 직접 `PolicyModal` 을 띄운다.
 */
import React, { useState } from "react";
import VerticalBar from "../icons/VerticalBar";
import PolicyModal from "../modal/PolicyModal";
import Link from "next/link";

/** 모든 페이지 하단에 들어가는 공통 푸터. */
function Footer() {
  const [isPolicyModalOpen, setIsPolicyModalOpen] = useState(false);

  const openPolicyModal = () => setIsPolicyModalOpen(true);
  const closePolicyModal = () => setIsPolicyModalOpen(false);

  return (
    <>
      <div className="flex flex-col gap-[24px] bg-page pt-[44px] pb-[72px] px-[20px] md:flex-row md:gap-0 md:px-[40px]">
        <div className="flex flex-col gap-[16px]">
          <div className="flex flex-wrap gap-x-[24px] gap-y-[12px] text-14 text-heading md:gap-[44px]">
            <div
              className="cursor-pointer"
              onClick={() =>
                window.open(
                  "https://codehana.notion.site/10bbb26750dd80988f5eeb08f3e34b6f?pvs=4",
                  "_blank",
                  "noopener,noreferrer"
                )
              }
            >
              교육소개
            </div>
            <Link href="/help/faq" className="cursor-pointer">
              문의하기
            </Link>
            <div className="cursor-pointer" onClick={openPolicyModal}>
              이용약관
            </div>
            <Link href="/privacy" className="cursor-pointer">
              개인정보처리방침
            </Link>
          </div>

          <div className="flex flex-col gap-[4px] text-14 text-body font-normal lg:flex-row lg:flex-wrap lg:gap-y-[4px]">
            <div className="flex items-center">
              <p>주식회사 코드하나</p>
              <div className="hidden px-3 lg:block">
                <VerticalBar />
              </div>
            </div>

            <div className="flex items-center">
              <p>고객센터: 02-313-8910</p>
              <div className="hidden px-3 lg:block">
                <VerticalBar />
              </div>
            </div>

            <div className="flex items-center">
              <p>사업자등록번호: 410-88-02542</p>
              <div className="hidden px-3 lg:block">
                <VerticalBar />
              </div>
            </div>

            <div className="flex items-center">
              <p>통신판매업신고번호: 제2023-서울서대문-1373</p>
              <div className="hidden px-3 lg:block">
                <VerticalBar />
              </div>
            </div>

            <p>
              주소: 서울 마포구 마포대로 12 한신오피스텔 1012호
            </p>
          </div>

          <div className="flex flex-col gap-[4px] text-14 text-body font-normal lg:flex-row lg:gap-0">
            <div>대표 조하영</div>
            <div className="hidden px-3 lg:block">
              <VerticalBar />
            </div>
            <div>개인정보보호책임자: 조하영</div>
          </div>

          <div className="text-14 text-body font-normal">
            Copyright ©Codehana.All rights reserved.
          </div>
        </div>
      </div>

      {/* 모달 추가 */}
      <PolicyModal isOpen={isPolicyModalOpen} onClose={closePolicyModal} />
    </>
  );
}

export default Footer;
